export const PURCHASE_MODAL = "PURCHASE_MODAL";
export const APPOINTMENT_MODAL = "APPOINTMENT_MODAL";
export const LOGIN_MODAL = "LOGIN_MODAL";